const LOCAL_DB = false; // use the local API on :7585 (only on localhost)
const TEST_API = true; // use the test.bojenjepobrojevima.rs API (only on localhost, ignored when LOCAL_DB)
const IS_DEBUG = false;
const ADMIN = false; // !!!

const hostname = typeof window !== "undefined" ? window.location.hostname : "";
// LOCAL_DB and TEST_API only count for a dev server, so a deployed build left with either on still calls prod.
const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

const debugGA = false;
const showDeliveryInfoBanner = false; // Info warning banner

interface IAppConfig {
  baseURL: string;
  debug: boolean;
  admin: boolean;
  debugGA: boolean;
  showDeliveryInfoBanner: boolean;
}

const appconfig: IAppConfig = {
  baseURL:
    LOCAL_DB && isLocalhost
      ? "http://localhost:7585/api"
      : (TEST_API && isLocalhost) || hostname === "test.bojenjepobrojevima.rs"
        ? "https://test.bojenjepobrojevima.rs/api"
        : "https://bojenjepobrojevima.rs/api",
  debug: IS_DEBUG,
  admin: ADMIN,
  debugGA,
  showDeliveryInfoBanner,
};

export default appconfig;
